module.exports = __webpack_public_path__ + "exljbris_-_museosans-700-webfont.34db7f9133f18d9c252e.woff2";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/exljbris_-_museosans-700-webfont.woff2
// module id = ../../../../../src/assets/fonts/exljbris_-_museosans-700-webfont.woff2
// module chunks = styles